import {PaymentAcceptStatus} from '../../core/services/impl/payment.service';
import {PaymentAuthorizationStatus} from '../sections/notifications/insurer-data-authorization-notification/insurer-data-authorization.component';
import {NotificationComponentKey} from '../../core/enums/components-keys';

export interface NotificationState {
    activeNotification?: NotificationComponentKey;
    message?: string;
    paymentMethod?: string;
    status?: number;
    paymentAcceptStatus?: PaymentAcceptStatus;
    paymentAuthorizationStatus?: PaymentAuthorizationStatus;
    registrationFailedStatus?: any;
}

export interface NextNotificationState {
    title: string;
    subtitle?: string;
    image: string;
    buttons: NextNotificationButtonConfig[];
}

export enum NextSuccessNotificationContext {
    DIAGNOSTIC_STATION = 'DIAGNOSTIC_STATION',
    PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
}

export interface NextNotificationDataConfig {
    context: NextSuccessNotificationContext;
    state: NextNotificationState;
}

export enum NextNotificationButtonAction {
    RESET_APP = 'RESET_APP',
    REDIRECT = 'REDIRECT',
}

export interface NextNotificationButtonConfig {
    label: string;
    action: NextNotificationButtonAction;
    redirectUrl?: string;
    cssClass?: string;
}
